export default __webpack_public_path__ + "static/media/Modal_Success_Now_Integrate.aad26e03.gif";